/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyInput = this.querySelector('[data-qty-input]');
    this.cartElement = document.querySelector('cart-form');
    this.submitButton = this.querySelector('[type="submit"]');
    this.termsCheckbox = document.querySelector('[data-pdp-tnc]');
    this.template = this.dataset.template;
  }

  connectedCallback() {
    this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.qtyBtns?.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    this.boundQtyInputChangeHandler = this.handleQtyInputChange.bind(this);
    ['change', 'blur'].forEach(eventType => {
      this.qtyInput?.addEventListener(eventType, this.boundQtyInputChangeHandler);
    });
    this.termsCheckbox?.addEventListener('change', this.handleTermsChange.bind(this));
    this.quickViewButton = this.querySelector('.quickshop--button');
    
    if(this.quickViewButton){
      this.quickViewButton.addEventListener('click',(event)=>{
        event.preventDefault();
        event.stopImmediatePropagation();
        let eventDetail = { 
          variant : this.querySelector('[name="id"]')?.value,
          handle : event.target.dataset.handle,
          element : event.target
        }
        document.dispatchEvent(new CustomEvent('Quickview:OpenProduct', { detail: eventDetail, bubbles: true, cancelable: false }));
      })
    }
    
    // Initialize character limit enforcement for personalization inputs
    this.initializeCharacterLimits();
    
    this.updateImageHeights();
  }

  updateProductDetails(container, variant) {
    (variant == false) ? this.toggleAddButton('disable') : this.toggleAddButton('enable', variant.available);
    if(variant){
      this.updateURLandID(variant);
      // Skip priceUpdate for collection page card format, but allow for quick shop
      const isProductCard = this.dataset.format === 'product-card';
      if (!isProductCard) {
        this.priceUpdate(container, variant);
      }
      const url = `${window.location.pathname}?variant=${variant.id}`;
      const section_id = document.querySelector('[data-product-container]')?.dataset.section;
      if (!section_id) return;
      fetch(`${url}?section_id=${section_id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if(document.querySelector(".pdp-media-wrapper") != null){
          document.querySelector(".pdp-media-wrapper").innerHTML = html.querySelector(".pdp-media-wrapper").innerHTML
          new productMediaPopup();
        }
        if(document.querySelector(".pdp-media-wrapper-mob") != null){
          document.querySelector(".pdp-media-wrapper-mob").innerHTML = html.querySelector(".pdp-media-wrapper-mob").innerHTML
          new productMediaPopup();
        }
        if(document.querySelector("[data-zoomMediaContainer]") != null){
          document.querySelector("[data-zoomMediaContainer]").innerHTML = html.querySelector("[data-zoomMediaContainer]").innerHTML
        }
        this.updateButtonFromSection(html, container);
        this.updateBulkPricing(html, variant); // Pass the parsed HTML
        this.renderPersonalizationDrawer(html, variant);
        this.reBindDrawerEvent();
      })
      .catch((error) => {
        console.error('Error updating product details:', error);
      });
    }
  }

  reBindDrawerEvent() {
    const personalizeBtn = document.querySelector('[data-toggleDrawer="component-personalization-drawer"]');
    const personalizeDrawer = document.getElementById('component-personalization-drawer');
    if (personalizeBtn && personalizeDrawer) {
      personalizeBtn.addEventListener('click', function(evt) {
        evt.preventDefault();
        personalizeDrawer.openDrawer(evt.currentTarget);
      });
    }
    // rest of the ATC button click
    this.form = this.querySelector('form');
    const submitBtn = this.form.querySelector('button[type=submit]');
    if(submitBtn){
      this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
    }
    
    // Reinitialize character limits for newly rendered inputs
    this.initializeCharacterLimits();
  }

  /**
   * Updates all price displays: bulk total, unit price, and sticky bar price.
   * @param {Object} params
   * @param {number} params.totalPrice - The total price (in cents).
   * @param {number} params.unitPrice - The unit price (in cents).
   */
  updateDisplayedPrices({ totalPrice, unitPrice }) {
    const totalPriceElement = document.querySelector('[data-bulk-total-price]');
    const unitPriceElement = document.querySelector('[data-bulk-unit-price]');
    const stickyPriceElement = document.querySelector('[data-sticky-product-price]');

    if (totalPriceElement) {
      totalPriceElement.setAttribute('data-bulk-total-price', totalPrice);
      totalPriceElement.textContent = Utility.formatMoney(totalPrice, window.globalSpace.money_format);
    }
    if (unitPriceElement) {
      unitPriceElement.setAttribute('data-bulk-unit-price', unitPrice);
      unitPriceElement.textContent = `(${Utility.formatMoney(unitPrice, window.globalSpace.money_format)}/each)`;
    }
    if (stickyPriceElement) {
      stickyPriceElement.textContent = Utility.formatMoney(totalPrice, window.globalSpace.money_format);
    }
  }

  /**
   * Render Price details based on current variant
   */
   priceUpdate(container,variant){
    const priceElements = container.querySelectorAll('[data-currentPrice]');
    if(!priceElements) return;
    const comparePriceElements = container.querySelectorAll('[data-comparePrice]');
    priceElements.forEach(priceElement => {
      priceElement.textContent = Utility.formatMoney(variant.price, window.globalSpace.money_format);
    });
    if (comparePriceElements) {
      comparePriceElements.forEach(comparePriceElement => {
        comparePriceElement.textContent = Utility.formatMoney(variant.compare_at_price, window.globalSpace.money_format);
        comparePriceElement.classList.toggle('d-none', !variant.compare_at_price || variant.compare_at_price <= 0 || variant.compare_at_price === variant.price);
      });
    }
    const totalPriceElement = document.querySelector('[data-bulk-total-price]');
    const unitPriceElement = document.querySelector('[data-bulk-unit-price]');
    document.querySelector('[data-base-price]').setAttribute('data-base-price', variant.price);
    if (totalPriceElement && unitPriceElement) {
      const quantity = parseInt(this.qtyInput?.value) || 1;
      const unitPrice = variant.price;
      const totalPrice = unitPrice * quantity;
      this.updateDisplayedPrices({ totalPrice, unitPrice });
    }
  }

  updateBulkPricing(html, variant) {
    if (!html) return;
    const discountTable = document.querySelector('.pdp-bulk');
    if (!discountTable) return;

    // Find the new bulk pricing table in the fetched HTML
    const newTableContent = html.querySelector('.pdp-bulk .bulk-list-wrapper');
    if (newTableContent) {
      const currentTableContent = discountTable.querySelector('.bulk-list-wrapper');
      currentTableContent.innerHTML = newTableContent.innerHTML;

      // Update price elements after table refresh
      const quantity = parseInt(this.qtyInput?.value) || 1;
      const discountEl = currentTableContent.querySelector('.bulk-list');
      const tiersData = discountEl?.getAttribute('data-discount-tiers');
      let unitPrice = variant.price;

      if (tiersData) {
        const tiers = JSON.parse(tiersData);
        
        // Check if quantity is below the first tier
        const [firstRange] = tiers[0].split(':');
        const [firstMin] = firstRange.split('-');
        const minTierQty = parseInt(firstMin);
        
        if (quantity < minTierQty) {
          // Use base price when quantity is below first tier
          unitPrice = variant.price;
        } else {
          for (const tier of tiers) {
            const [range, price] = tier.split(':');
            const [min, max] = range.split('-');
            const minQty = parseInt(min);
            const maxQty = max === '+' ? Infinity : parseInt(max);
            if (quantity >= minQty && quantity <= maxQty) {
              unitPrice = parseFloat(price) * 100;
              break;
            }
          }
        }
      }
      const totalPriceElement = document.querySelector('[data-bulk-total-price]');
      const unitPriceElement = document.querySelector('[data-bulk-unit-price]');
      if (totalPriceElement && unitPriceElement) {
        const totalPrice = unitPrice * quantity;
        this.updateDisplayedPrices({ totalPrice, unitPrice });
      }
    }
  }

  updateButtonFromSection(html, container) {
    const currentAddToCartBtn = container.querySelector('.pdp-sticky .buy-buttons');
    const newAddToCartBtn = html.querySelector('.pdp-sticky .buy-buttons');
    if (currentAddToCartBtn && newAddToCartBtn) {
      currentAddToCartBtn.outerHTML = newAddToCartBtn.outerHTML;
    }
    const currentPersonalizeBtn = container.querySelector('button[data-toggleDrawer="component-personalization-drawer"]');
    const newPersonalizeBtn = html.querySelector('button[data-toggleDrawer="component-personalization-drawer"]');
    if (currentPersonalizeBtn && newPersonalizeBtn) {
      currentPersonalizeBtn.outerHTML = newPersonalizeBtn.outerHTML;
    }
  }

  renderPersonalizationDrawer(html, variant) {
    // Find the new drawer content in the parsed HTML
    const newDrawerContent = html.querySelector('#component-personalization-drawer .drawer-wrapper');
    if (newDrawerContent) {
      const currentDrawerContent = document.querySelector('.personalization-drawer .drawer-wrapper');
      if (currentDrawerContent) {
        currentDrawerContent.innerHTML = newDrawerContent.innerHTML;
      }
    }
    // Update hidden variant input
    const form = document.querySelector('.personalization-form');
    if (form) {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = variant.id;
      }
    }

    const personalizationDrawerModal = document.querySelector('#component-personalization-drawer #tnc-modal');
    if (personalizationDrawerModal) {
      const tncModalLink = document.querySelector('#tnc-modal');
      tncModalLink?.addEventListener('click', this.openTnCModal.bind(this));
    }
  }

  openTnCModal(event) {
    event.preventDefault();
    const tncModal = document.getElementById('personalize-tnc-modal');
    tncModal.show(event.currentTarget);
  }

  /**
     * Toggle the button based on product availability ( add to cart / soldOut )
     * @param {Text} status enable / disable
     * @param {Boolean} variantAvailable true/false
     */
   toggleAddButton(status, variantAvailable) {
    if (!this.submitButton) return;
    const addText = this.submitButton.querySelector('.add-text');
    const isVirtualRace = this.closest('[data-product-container]')?.dataset?.templateSuffix === 'virtual-race';
    if (status === 'disable' || (!variantAvailable)) {
        this.submitButton.setAttribute('disabled', true);
        if (addText) addText.textContent = status === 'disable' ? window.variantStrings.unavailable : window.variantStrings.soldOut;
    } else {
        this.submitButton.removeAttribute('disabled');
        if (addText) {
          if (isVirtualRace) {
            addText.textContent = 'Sign Up';
          } else {
            addText.textContent = this.form.classList.contains('cart-upsell-form') ? window.variantStrings.upsellAddText : window.variantStrings.addToCart;
          }
        }
    }
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant || !this.form) return;
    if (this.dataset.format === 'product-page') window.history.replaceState({}, '', `${this.form.dataset.url}?variant=${currentVariant.id}`);
    this.form.querySelector('input[name="id"]').value = currentVariant.id;
   }

  /*** Product Form Terms & Condition checkbox ****/
  validateTermsAndConditions(form) {
    const termsCheckbox = form?.querySelector('[data-pdp-tnc]');
    if (!termsCheckbox || termsCheckbox.checked) return true;
    const tncContainer = termsCheckbox.closest('.pdp-tnc');
    if (!tncContainer.querySelector('.terms-error')) {
      const errorMessage = document.createElement('div');
      errorMessage.classList.add('terms-error', 'text-danger', 'mt-2');
      errorMessage.textContent = 'Please accept the Terms & Conditions';
      tncContainer.appendChild(errorMessage);
    }
    this.termsCheckbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return false;
  }

  handleTermsChange() {
    const errorMessage = document.querySelector('.terms-error');
    if (errorMessage && this.termsCheckbox.checked) {
      errorMessage.remove();
    }
  }

  /** Virtual Race default option to be unselected */
   virtualRaceDefaultOptionValidation(){
     if(this.template && this.template == 'virtual-race' && this.querySelector('[data-select-field]')){
      let return_value = true;
      this.querySelectorAll('input[name^="options["][data-select-field]').forEach( input =>{
        if (input.checked) {
          if(input.closest('.select')){
            input.closest('.select').classList.add('error-please-select');
            setTimeout(()=>{
              input.closest('.select').classList.remove('error-please-select');
            },2400);
          }
          return_value = false;
        }
      });
      return return_value;
     }
   }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    let clickedPersonalizeButton = evt.currentTarget.dataset.type;
    const hasPersonalization = document.querySelector('#personalizeform');
    if (hasPersonalization && clickedPersonalizeButton == "personalized-atc-form") {
      let response = this.validationBeforeATC();
      if(!response) return;
    }
    const targetForm = evt.target.closest('.product-form');
    if (!this.validateTermsAndConditions(targetForm)) {
      return;
    }

    if (this.template && this.template == 'virtual-race' && this.querySelector('[data-select-field]')) {
      if(!this.virtualRaceDefaultOptionValidation()) return;
    }

    const addItems = [];
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');

    // addItems.push(JSON.parse(Utility.serializeForm(this.form)));
    const formData = Utility.serializeForm(this.form);
    formData.properties = formData.properties || {};
    const processingTime = this.closest('.product-form').getAttribute('data-processing-time');
    if (processingTime) {
      formData.properties['_processing_time'] = processingTime;
    }
    if (hasPersonalization) {
      formData.properties = formData.properties || {};

      let allPersonalizationText = '';
      const processedInputs = new Set();

      // Process all inputs in DOM order to maintain sequence
      const allPersonalizationInputs = document.querySelectorAll('[data-personalization-input]');
      
      allPersonalizationInputs.forEach(input => {
        if (processedInputs.has(input)) return; // Skip already processed inputs
        
        if (input.type === 'radio') {
          // Handle radio buttons - add to personalization text instead of separate property
          if (input.checked && input.value.toLowerCase() !== 'n/a') {
            let name = input.name.replace('properties[', '').replace(']', '');
            allPersonalizationText += `${name}: ${input.value}\n`;
          }
          processedInputs.add(input);
        } else if (input.value && (input.type === 'text' || input.type === 'number')) {
          // Check if this input is part of a multiline group
          const multilineGroup = input.closest('.multiline[data-personalization-wrapper]');
          
          if (multilineGroup && !processedInputs.has(multilineGroup)) {
            // Handle multiline group
            const inputs = multilineGroup.querySelectorAll('[data-personalization-input]');
            let combined = '';
            inputs.forEach(groupInput => {
              const label = groupInput.getAttribute('data-label') || groupInput.name;
              if (groupInput.value) {
                combined += `[${label}: ${groupInput.value}]`;
              }
              processedInputs.add(groupInput);
            });
            if (combined) {
              allPersonalizationText += combined + '\n';
            }
          } else if (!multilineGroup) {
            // Handle single text/number input
            let name = input.name.replace('properties[', '').replace(']', '');
            allPersonalizationText += `${name}: ${input.value}\n`;
            processedInputs.add(input);
          }
        }
      });

      // Add combined personalization if we have any
      if (allPersonalizationText.trim()) {
        formData.properties['Personalization'] = allPersonalizationText.trim();
      }
    }

    addItems.push(formData);

    let cartSectionID = 'component-cart-drawer';
    if(window.globalSpace.template == 'cart'){
      cartSectionID = document.getElementById('cart--items')?.dataset.id || 'template-cart';
    }

    const body = JSON.stringify({
      items: addItems,
      sections: `${cartSectionID},header`
    });

    fetch(`${routes.cart_add_url}`, { ...Utility.fetchConfig(), body })
    .then((response) => response.json())
    .then((res) => {
      const dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
      if(dataJSON.errors){
        window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
          type: 'error',
          timeout: 5000
        });
        // Check if error is related to inventory/quantity issues
        const errorMessage = typeof dataJSON.errors === 'string' ? dataJSON.errors : JSON.stringify(dataJSON.errors);
        const isInventoryError = errorMessage.toLowerCase().includes('maximum quantity of this') || errorMessage.toLowerCase().includes('already in your cart.') || errorMessage.toLowerCase().includes('due to availability') || errorMessage.toLowerCase().includes('were added to your cart');
        // Refresh cart data to ensure display is in sync with actual cart state
        if(this.cartElement){
          this.cartElement.getCartData();
          // Only open cart drawer if it's an inventory-related error
          if(isInventoryError){
            setTimeout(() => {
              const cartDrawer = document.getElementById('component-cart-drawer');
              if (cartDrawer) {
                cartDrawer.openDrawer(this.submitButton);
              }
            }, 1000);
          }
        }
        return;
      }

      eventBus.publish(PUB_SUB_EVENTS.productATC, {
        data: {
          item: dataJSON.items[0]
        },
      });
      document.querySelector('#PopupModal-quickshop .close-quickshop')?.dispatchEvent(new Event('click'))

      // Reset personalization form
      if (hasPersonalization) {
        document.querySelector('#personalizeform').reset();
        // Reset custom select dropdowns
        const customSelects = document.querySelectorAll('custom-select');
        customSelects.forEach(select => {
          const firstOption = select.querySelector('.sortby_options');
          const firstLabel = select.querySelector('.option_txt span')?.textContent;
          if (firstOption && firstLabel) {
            select.querySelector('.tab_toggle .option_txt').textContent = firstLabel;
            select.querySelectorAll('li.form-check').forEach(li => li.classList.remove('selected'));
            firstOption.closest('li.form-check').classList.add('selected');
            firstOption.checked = true;
          }
        });

        // Reset regular radio buttons to first option
        const radioGroups = document.querySelectorAll('.personalization_radio');
        radioGroups.forEach(group => {
          const firstRadio = group.querySelector('input[type="radio"]');
          if (firstRadio) {
            firstRadio.checked = true;
          }
        });

        // Clear data-multiline-processed attribute
        document.querySelectorAll('[data-multiline-processed]').forEach(input => {
          input.removeAttribute('data-multiline-processed');
        });
      }

      if (this.qtyInput) {
        const minQty = Number(this.qtyInput.getAttribute('min')) || 1;
        this.qtyInput.value = minQty;
      }
      if (targetForm.querySelector('[data-bulk-unit-price]')) {
        const unitPriceElement = targetForm.querySelector('[data-base-price]');
        if (unitPriceElement && this.qtyInput) {
          const unitPrice = Number(unitPriceElement.getAttribute('data-base-price')) || 0;
          const minQty = Number(this.qtyInput.getAttribute('min')) || 1;
          const totalPrice = unitPrice * minQty;
          this.updateDisplayedPrices({ totalPrice, unitPrice });
        }
      }
      if(this.cartElement){
        this.cartElement?._updateCart(dataJSON.sections, this.submitButton);
      }else{
        window.location.href = window.routes.cart_fetch_url;
      }
    })
    .catch((e) => {
      window.notificationEle.updateNotification('Error', e, {
        type: 'error',
        timeout: 5000
      });
    })
    .finally(() => {
      this.submitButton.classList.remove('loading');
      this.submitButton.removeAttribute('aria-disabled');
    });
  }

  /**
   * Product Form Quantity Input update action
   */
  manageQtyBtn(event) {
    event.preventDefault();
    const currentTarget = event.currentTarget;
    const action = currentTarget.dataset.for || 'increase';
    const qtyContainer = currentTarget.closest('[data-qty-container]');
    const decreaseBtn = qtyContainer.querySelector('[data-for="decrease"]');
    const currentQty = parseInt(this.qtyInput.value) || 1;
    const minQty = parseInt(this.qtyInput.getAttribute('min')) || 1;
    const newQty = Math.max((action === 'decrease' ? currentQty - 1 : currentQty + 1), minQty);
    this.qtyInput.value = newQty;
    decreaseBtn.classList.toggle('disabled', newQty <= minQty);

    // Update pricing and personalization
    this.updateQuantityDependentElements(newQty);

    return newQty;
  }

  /**
   * Common method to update all quantity-dependent elements (pricing, personalization, etc.)
   * @param {number} newQty - The new quantity value
   */
  updateQuantityDependentElements(newQty) {
    const container = this.querySelector('.product-qty-main');
    const totalPriceElement = document.querySelector('[data-bulk-total-price]');
    const unitPriceElement = document.querySelector('[data-bulk-unit-price]');

    if (!container || (!totalPriceElement && !unitPriceElement)) return;

    const discountEl = this.querySelector('[data-discount-tiers]');
    const tiersData = discountEl?.getAttribute('data-discount-tiers');
    let unitPrice = null;

    if (tiersData) {
      const tiers = JSON.parse(tiersData);
      // Check if quantity is below the first tier
      const [firstRange] = tiers[0].split(':');
      const [firstMin] = firstRange.split('-');
      const minTierQty = parseInt(firstMin);
      if (newQty < minTierQty) {
        const basePriceElement = document.querySelector('[data-base-price]');
        unitPrice = basePriceElement ? parseFloat(basePriceElement.getAttribute('data-base-price')) / 100 : null;
      } else {
        for (const tier of tiers) {
          const [range, price] = tier.split(':');
          let min, max;
          if (range.includes('-')) {
            [min, max] = range.split('-');
          } else {
            min = range;
            max = '+';
          }
          const minQty = parseInt(min);
          const maxQty = max === '+' ? Infinity : parseInt(max);
          if (newQty >= minQty && newQty <= maxQty) {
            unitPrice = parseFloat(price);
            break;
          }
        }
      }
    } else {
      const basePriceElement = document.querySelector('[data-base-price]');
      unitPrice = basePriceElement ? parseFloat(basePriceElement.getAttribute('data-base-price')) / 100 : null;
    }

    if (unitPrice != null) {
      const totalPrice = unitPrice * newQty;
      this.updateDisplayedPrices({ totalPrice: totalPrice * 100, unitPrice: unitPrice * 100 });
    }

    // Update personalization quantity inputs
    const personalizationQtyInput = document.querySelector('[data-personalization-qty]');
    if (personalizationQtyInput) {
      personalizationQtyInput.value = newQty;
    }
  }

  handleQtyInputChange(event) {
    const input = event.target;
    const min = parseInt(input.min || 1, 10);
    const max = input.max ? parseInt(input.max, 10) : null;
    let value = parseInt(input.value, 10);
    if (isNaN(value)) value = min;
    if (value < min) {
      value = min;
    } else if (max && value > max) {
      value = max;
    }
    input.value = value;

    // Update decrease button state
    const qtyContainer = input.closest('[data-qty-container]');
    if (qtyContainer) {
      const decreaseBtn = qtyContainer.querySelector('[data-for="decrease"]');
      if (decreaseBtn) {
        decreaseBtn.classList.toggle('disabled', value <= min);
      }
    }

    // Use the common method to update pricing and personalization
    this.updateQuantityDependentElements(value);
  }

  /**
   * Product form validation specific for personalization form
   */
   validationBeforeATC(){
    const personalizeform = document.querySelector('#personalizeform');
    if (!personalizeform) return;
    let allInputFields = personalizeform.querySelectorAll('[data-personalizeoption] input') || [];
    let checkedInputNames= [];
    let totalPersonalizeCost = 0;
    let returnvalue = true;

    // Group validation (like Cloud Commerce: At least 1 required in a group)
    const multilineGroups = personalizeform.querySelectorAll('[data-personalization-wrapper][data-group-required="true"]');
    if (multilineGroups.length > 0) {
      multilineGroups.forEach(group => {
        const inputs = group.querySelectorAll('.multi-text-required');
        const anyFilled = Array.from(inputs).some(input => input.value.trim() !== '');
        if (!anyFilled) {
          inputs.forEach(input => {
            const error = input.closest('[data-personalizeoption]')?.dataset.error || 'At least one field must be filled';
            this.displayErrorMessage(input, error);
          });
          returnvalue = false;
        } else {
          // Clear any error messages if at least one field is filled
          inputs.forEach(input => {
            input.setAttribute('data-skip-validation', 'true');
            let parentElement = input.closest('[data-parentElement]');
            if (parentElement) {
              parentElement.classList.remove('enableError');
              parentElement.removeAttribute('data-errorby');
            }
          });
        }
      });
    }

    allInputFields.forEach(input =>{
      if (input.dataset.skipValidation === "true") return;
      let inputType = input.type;
      let inputName = input.name;
      let inputLimit = inputType === 'text' ? (input.maxlength || input.max) : input.max;
      let inputRequired = input.required;
      let inputElement,inputErrorMessage = undefined;
      switch(inputType){
        case 'text':
          if(checkedInputNames.includes(inputName)) break;
          checkedInputNames.push(inputName);
           inputElement = personalizeform.querySelector(`[name="${inputName}"]`);
           inputErrorMessage = inputElement.closest('[data-personalizeoption]').dataset.error;
          if(inputRequired && inputElement.value == ""){
            this.displayErrorMessage(inputElement,inputErrorMessage);
            returnvalue = false;
          }
          if(inputLimit && inputElement.value.length > inputLimit){
            this.displayErrorMessage(inputElement, inputErrorMessage);
            returnvalue = false;
          }
          if(inputType == 'text' && inputElement.dataset.regex == "upper" && inputElement.value){
            let isUppercase = (inputElement.value === inputElement.value.toUpperCase() )? true:false;
            if(!isUppercase){
              this.displayErrorMessage(inputElement, inputErrorMessage);
              returnvalue = false;
            }
          }
          if(inputType == 'text' && inputElement.dataset.regex == "namesUpper" && inputElement.value){
            let isNamesUpper = /^[A-Z\s]+$/.test(inputElement.value);
            if(!isNamesUpper){
              this.displayErrorMessage(inputElement, inputErrorMessage);
              returnvalue = false;
            }
          }
          if(inputType == 'text' && inputElement.value){
            let isAlphaNumeric = /^[a-zA-Z0-9 ]+$/.test(inputElement.value);
            if(!isAlphaNumeric){
              this.displayErrorMessage(inputElement, inputErrorMessage);
              returnvalue = false;
            }
          }
          if(inputType == 'text' && inputElement.dataset.regex == "number" && inputElement.value){
            let isNumberOnly = /^[0-9]+$/.test(inputElement.value);
            if(!isNumberOnly){
              this.displayErrorMessage(inputElement, inputErrorMessage);
              returnvalue = false;
            }
          }
          if(inputElement.value && inputElement.dataset.price){
            totalPersonalizeCost += Number(inputElement.dataset.price);
          }
        break;
        case 'number':
           if(checkedInputNames.includes(inputName)) break;
          checkedInputNames.push(inputName);
           inputElement = personalizeform.querySelector(`[name="${inputName}"]`);
           inputErrorMessage = inputElement.closest('[data-personalizeoption]').dataset.error;
           if(inputRequired && inputElement.value == ""){
            this.displayErrorMessage(inputElement,inputErrorMessage);
            returnvalue = false;
            return false
          }
          let input_maxLimit = Number(input.dataset.max);
          if(input_maxLimit && inputElement.value.length > input_maxLimit){
            this.displayErrorMessage(inputElement, inputErrorMessage);
            returnvalue = false;
            return false
          }
          if((inputType == 'text' || inputType == 'number') && inputElement.dataset.regex == "number"){
            let isNumberOnly = /^[0-9]+$/.test(inputElement.value);
            if(!isNumberOnly){
              this.displayErrorMessage(inputElement, inputErrorMessage);
              returnvalue = false;
              return false
            }
          }
           if(inputElement.value && inputElement.dataset.price){
            totalPersonalizeCost += Number(inputElement.dataset.price)
          }
        break;
        case 'radio':
           if(checkedInputNames.includes(inputName)) break;
          checkedInputNames.push(inputName);
          inputElement = personalizeform.querySelector(`[name="${inputName}"]`);
          inputErrorMessage = inputElement.closest('[data-personalizeoption]').dataset.error;
          let isInputChecked = personalizeform.querySelector(`input[name="${inputName}"]:checked`);
          if(inputRequired && (isInputChecked == null || isInputChecked == undefined || isInputChecked.value == "N/a" )){
            this.displayErrorMessage(inputElement, inputErrorMessage);
            returnvalue = false;
            return false
          }
           if(isInputChecked && isInputChecked.dataset.price){
            totalPersonalizeCost += Number(isInputChecked.dataset.price)
          }
        break;
        case 'checkbox':
          if(inputRequired && input.checked == false ){
            this.displayErrorMessage(input, "Acknowledgement is required!");
            returnvalue = false;
            return;
          }
      }
    });

    let additionalCostsInput = this.form.querySelector('input[name="properties[additional cost]"]');
    if (totalPersonalizeCost > 0) {
      if (additionalCostsInput) {
        additionalCostsInput.value = `$${totalPersonalizeCost.toFixed(2)}`;
      } else {
        additionalCostsInput = document.createElement('input');
        additionalCostsInput.type = 'hidden';
        additionalCostsInput.name = 'properties[additional cost]';
        additionalCostsInput.value = `$${totalPersonalizeCost.toFixed(2)}`;
        this.form.appendChild(additionalCostsInput);
      }
    } else if (additionalCostsInput) {
      additionalCostsInput.remove();
    }
    return returnvalue;
   }
   

   /**
    * Shows error message on personalize form options
    */
   displayErrorMessage(element,message){
    let parentElement = element.closest('[data-parentElement]');
    if(parentElement){
      parentElement.classList.add('enableError');
      parentElement.setAttribute('data-errorby',message);
      setTimeout(()=>{
        parentElement.classList.remove('enableError');
        parentElement.removeAttribute('data-errorby');
    },5000);
    }
   }
   /**
    * Product Card Hover effect and Image size
    */
   updateImageHeights() {
    let card = this.closest('.card-product');
    if(card){
         const wrapper = card.querySelector('.product--media.product-images-wrapper');
          if (wrapper) {
            const height = wrapper.offsetHeight;
            if (height > 0) {
              card.style.setProperty('--parent-width', `${height}px`);
            }
          }
    }
  }

  /*** Initialize character limit enforcement for personalization inputs */
  initializeCharacterLimits() {
    if (!this._charLimitDelegated) {
      document.addEventListener('input', this.handleInputLimit.bind(this), true);
      document.addEventListener('keydown', this.handleKeydownLimit.bind(this), true);
      this._charLimitDelegated = true;
    }
  }

  /**
   * Handle input events with character limit enforcement
   * @param {Event} event - The input event
   */
  handleInputLimit(event) {
    const input = event.target;
    if (!input.matches('[data-personalization-input][max]')) return;
    const maxLength = parseInt(input.getAttribute('max'));
    if (!maxLength || maxLength <= 0) return;
    if (input.value.length > maxLength) {
      input.value = input.value.substring(0, maxLength);
    }
  }

  /**
   * Handle keydown events to prevent excess typing
   * @param {KeyboardEvent} event - The keydown event
   */
  handleKeydownLimit(event) {
    const input = event.target;
    if (!input.matches('[data-personalization-input][max]')) return;
    const maxLength = parseInt(input.getAttribute('max'));
    if (!maxLength || maxLength <= 0) return;
    const currentLength = input.value.length;
    // Allow navigation, deletion, and special keys
    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'PageUp', 'PageDown'];
    if (allowedKeys.includes(event.key)) return;
    // Allow if there's a selection (user can replace selected text)
    if (input.selectionStart !== input.selectionEnd) return;
    // Prevent typing if at max length
    if (currentLength >= maxLength) {
      event.preventDefault();
    }
  }

}
customElements.define('product-form', ProductForm);
